import * as DialogRadix from '@radix-ui/react-dialog';
import classNames from 'classnames';

import { CrossIcon, SmsBundleTierCheckIcon } from '../../atoms/Icon';

import './sms-bundle-tier-modal.scss';

export type SmsBundleTierModalRow = {
  value: string;
  label: string;
  priceLabel: string;
  oldPriceLabel?: string;
};

export type SmsBundleTierModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  closeAriaLabel: string;
  rows: SmsBundleTierModalRow[];
  selectedValue: string | null;
  onSelect: (value: string) => void;
};

export const SmsBundleTierModal = ({
  open,
  onOpenChange,
  title,
  closeAriaLabel,
  rows,
  selectedValue,
  onSelect,
}: SmsBundleTierModalProps) => (
  <DialogRadix.Root open={open} onOpenChange={onOpenChange}>
    <DialogRadix.Portal>
      <DialogRadix.Overlay className="payflow-ui-dialog__overlay sms-bundle-tier-modal__overlay" />
      <DialogRadix.Content className="payflow-ui sms-bundle-tier-modal">
        <div className="sms-bundle-tier-modal__header">
          <DialogRadix.Title className="sms-bundle-tier-modal__title">{title}</DialogRadix.Title>
          <DialogRadix.Close asChild>
            <button type="button" className="sms-bundle-tier-modal__close" aria-label={closeAriaLabel}>
              <CrossIcon />
            </button>
          </DialogRadix.Close>
        </div>

        <ul className="sms-bundle-tier-modal__list" role="radiogroup" aria-label={title}>
          {rows.map((row) => {
            const isSelected = row.value === selectedValue;

            return (
              <li key={row.value}>
                <button
                  type="button"
                  role="radio"
                  aria-checked={isSelected}
                  className={classNames('sms-bundle-tier-modal__row', {
                    'sms-bundle-tier-modal__row--selected': isSelected,
                  })}
                  onClick={() => onSelect(row.value)}
                >
                  <span className="sms-bundle-tier-modal__row-label">{row.label}</span>
                  <span className="sms-bundle-tier-modal__row-price-wrapper">
                    <span className="sms-bundle-tier-modal__row-price">{row.priceLabel}</span>
                    {row.oldPriceLabel && (
                      <span className="sms-bundle-tier-modal__row-old-price">{row.oldPriceLabel}</span>
                    )}
                  </span>
                  {isSelected ? (
                    <SmsBundleTierCheckIcon className="sms-bundle-tier-modal__check-icon" />
                  ) : (
                    <span className="sms-bundle-tier-modal__radio" aria-hidden="true" />
                  )}
                </button>
              </li>
            );
          })}
        </ul>
      </DialogRadix.Content>
    </DialogRadix.Portal>
  </DialogRadix.Root>
);
